module.exports = __webpack_public_path__ + "img/logo_white.58f0b585.svg";